import { CircularProgress } from "@mui/material";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import DataGrid from "@poseidon/ui/components/DataGrid";
import { DataGridContainer } from "@poseidon/ui/components/DataGridContainer";
import { columns } from "../components/columns";
import { useSailors } from "../hooks/useSailors";

export default function ListSailors() {
  const { sailors, loading, error } = useSailors();
  const { setError } = useErrorMessage();
  if (error) {
    setError(error);
  }

  if (loading || !sailors) {
    return (
      <CircularProgress sx={{ alignSelf: "center", justifySelf: "center" }} />
    );
  }

  return (
    <DataGridContainer>
      <DataGrid
        useSessionStorageForPagination
        id="sailors"
        columns={columns}
        rows={sailors}
        doubleClickSlug="sailors"
        initialState={{
          sorting: {
            sortModel: [{ field: "createdAt", sort: "desc" }],
          },
        }}
      />
    </DataGridContainer>
  );
}
